import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Users.css";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  /* ================= FETCH USERS ================= */
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/v1/users/admin/users", {
        headers: { "x-auth-token": localStorage.getItem("token") },
      });
      setUsers(res.data);
    } catch {
      alert("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  /* ================= DELETE USER ================= */
  const handleDelete = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      await axios.delete(`/api/v1/users/admin/deleteusers/${userId}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      });
      alert("User deleted successfully");
      fetchUsers();
    } catch {
      alert("Failed to delete user");
    }
  };

  /* ================= UPDATE ROLE ================= */
  const handleRoleUpdate = async (userId, role) => {
    try {
      await axios.put(
        `/api/v1/users/admin/updateuserrole/${userId}`,
        { role },
        { headers: { "x-auth-token": localStorage.getItem("token") } }
      );
      alert("User role updated successfully");
      fetchUsers();
    } catch {
      alert("Failed to update user role");
    }
  };

  /* ================= REGISTER USER ================= */
  const handleRegister = async (e) => {
    e.preventDefault();
    setRegisterLoading(true);

    try {
      await axios.post("/api/v1/auth/register", formData, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      });
      alert("User registered successfully");
      fetchUsers();
      setIsModalVisible(false);
      setFormData({ name: "", email: "", password: "" });
    } catch {
      alert("Failed to register user");
    } finally {
      setRegisterLoading(false);
    }
  };

  /* ================= USER STATS ================= */
  const totalUsers = users.length;
  const totalAdmins = users.filter((u) => u.role === "admin").length;
  const totalRegularUsers = totalUsers - totalAdmins;

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="users-container">
      {/* ================= STATS ================= */}
      <div className="user-stats">
        <h3>User Statistics</h3>
        <p>Total Users: {totalUsers}</p>
        <p>Total Admins: {totalAdmins}</p>
        <p>Total Regular Users: {totalRegularUsers}</p>
      </div>

      {/* ================= VIEW TOGGLE ================= */}
      <button
        className="btn"
        onClick={() => setViewMode(viewMode === "grid" ? "table" : "grid")}
      >
        Switch to {viewMode === "grid" ? "Table View" : "Grid View"}
      </button>

      {/* ================= GRID VIEW ================= */}
      {viewMode === "grid" && (
        <div className="users-grid">
          {users.map((user) => (
            <div className="user-card" key={user._id}>
              <img
                src={`https://randomuser.me/api/portraits/lego/${Math.floor(
                  Math.random() * 10
                )}.jpg`}
                alt="user"
              />
              <h4>{user.username || "User"}</h4>
              <p>{user.email}</p>
              <p className="role">{user.role}</p>

              <div className="card-actions">
                <button
                  className="btn-primary"
                  onClick={() =>
                    handleRoleUpdate(
                      user._id,
                      user.role === "admin" ? "user" : "admin"
                    )
                  }
                >
                  {user.role === "admin" ? "Make User" : "Make Admin"}
                </button>

                <button
                  className="btn-delete"
                  onClick={() => handleDelete(user._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ================= TABLE VIEW ================= */}
      {viewMode === "table" && (
        <table className="users-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user.email}</td>
                <td>{user.role}</td>
                <td>
                  <button
                    className="btn-primary"
                    onClick={() =>
                      handleRoleUpdate(
                        user._id,
                        user.role === "admin" ? "user" : "admin"
                      )
                    }
                  >
                    Toggle Role
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => handleDelete(user._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ================= REGISTER BUTTON ================= */}
      <button className="btn-primary" onClick={() => setIsModalVisible(true)}>
        Register New User
      </button>

      {/* ================= MODAL ================= */}
      {isModalVisible && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Register New User</h3>
            <form onSubmit={handleRegister}>
              <input
                type="text"
                placeholder="Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                required
              />
              <button
                type="submit"
                className="btn-primary"
                disabled={registerLoading}
              >
                {registerLoading ? "Registering..." : "Register"}
              </button>
              <button
                type="button"
                className="btn"
                onClick={() => setIsModalVisible(false)}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {loading && <p>Loading users...</p>}
    </div>
  );
};

export default Users;
